export default __webpack_public_path__ + "static/media/pic1.f276c3e2.jpg";